
import { defineComponent, ref, onMounted, watch } from "vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { Dropzone } from "dropzone";

import { hideModal } from "@/core/helpers/dom";
import ApiService from "@/core/services/ApiService";

export default defineComponent({
  name: "upload-custom-evidence-modal",
  components: {},
  props: {
    evidence: { type: Object, required: true },
    incoming: { type: Object, required: true },
  },
  emits: ["add-evidence"],
  setup(props, { emit }) {
    const uploadCustomDocEvidenceModalRef = ref<HTMLElement | null>(null);
    const submitButton = ref<HTMLButtonElement | null>(null);
    const dropRef = ref(null);
    const dropzone = ref<Dropzone>(null);
    const isAddedFile = ref(false);

    onMounted(async () => {
      if (dropRef.value !== null) {
        dropzone.value = new Dropzone(dropRef.value, {
          url: `${process.env.VUE_APP_API_URL}imgupload`,
          paramName: "file", // The name that will be used to transfer the file
          maxFiles: 1,
          maxFilesize: 10, // MB
          addRemoveLinks: true,
          acceptedFiles: ".doc, .docx, .pdf",
          autoProcessQueue: false,
        });

        dropzone.value?.on("addedfile", function () {
          isAddedFile.value = true;
        });

        dropzone.value?.on("removedfile", function () {
          isAddedFile.value = false;
        });
      }
    });

    const formSubmit = async () => {
      if (!isAddedFile.value) {
        Swal.fire({
          text: "Please upload the image!",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "OK!",
          customClass: {
            confirmButton: "btn fw-bold btn-light-danger",
          },
        });

        return;
      }

      // eslint-disable-next-line
      submitButton.value!.disabled = true;
      // Activate indicator
      submitButton.value?.setAttribute("data-kt-indicator", "on");

      try {
        // eslint-disable-next-line
        const formData: any = new FormData();
        formData.append("upload", dropzone.value.getAcceptedFiles()[0]);
        const res = await ApiService.post("imgupload", formData);

        if (res.data.success) {
          const imgUrl = res.data.data.url;
          const resp = await ApiService.put(
            `chargebacks/incoming/${props.incoming.id}?action=custom_page&img_url=${imgUrl}&evidence_id=${props.evidence.id}&active=1`,
            props.evidence.template_html
          );

          if (resp.data.success) {
            Swal.fire({
              position: "bottom",
              text: "Custom Evidence Page Successfully Added!",
              icon: "success",
              showConfirmButton: false,
              timer: 2000,
            }).then(function () {
              emit("add-evidence");
              hideModal(uploadCustomDocEvidenceModalRef.value);
            });
          } else {
            Swal.fire({
              text: resp.data.error.message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Try again!",
              customClass: {
                confirmButton: "btn fw-bold btn-light-danger",
              },
            });
          }
        } else {
          Swal.fire({
            text: res.data.error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Try again!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        }
      } catch (e) {
        Swal.fire({
          text: e.response.data.error
            ? e.response.data.error.message
            : "Something went wrong!",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Try again!",
          customClass: {
            confirmButton: "btn fw-bold btn-light-danger",
          },
        });
      }

      submitButton.value?.removeAttribute("data-kt-indicator");
      // eslint-disable-next-line
      submitButton.value!.disabled = false;
    };

    return {
      submitButton,
      formSubmit,
      uploadCustomDocEvidenceModalRef,
      dropRef,
    };
  },
});
